/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Listaspectemptyaspect8Inputs */

const de__class_listaspectemptyaspect8 = /** @type {(inputs: _Class_Listaspectemptyaspect8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leer`)
};

/**

* @param {_Class_Listaspectemptyaspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_listaspectemptyaspect8 = /** @type {((inputs?: _Class_Listaspectemptyaspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Listaspectemptyaspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_listaspectemptyaspect8(inputs)
});
export { _class_listaspectemptyaspect8 as "_class_ListAspectEMPTYAspect" }